
















import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import "./thankyou.less";
import { translate } from "../../services/translation/translation";

@Component({})
export default class ThankYou extends Vue {
  mounted() {
    this.scrolltoTop();
  }

  refresh() {
    window.location.reload(true);
  }

  trans(key) {
    return translate(key);
  }

  scrolltoTop() {
    $("#thank-you").fadeIn(300, function() {
      $("html, body").animate(
        {
          scrollTop: $("#thank-you")!.offset()!.top - 144
        },
        500,
        "linear"
      );
    });
  }
}
